<template>
	<font-awesome-icon v-if="fontawesome" :icon="icon" />
	<img v-else :src="path" />
</template>

<script lang="ts" setup>
	import { computed } from 'vue'

	const props = defineProps({
		icon: {
			type: Array,
			default: undefined
		}
	})

	const fontawesome = computed(() => {
		if (!props.icon) {
			return false
		}

		return props.icon[0] == 'fas' || props.icon[0] == 'far' || props.icon[0] == 'fab'
	})

	const path = computed(() => {
		if (!props.icon || props.icon.length < 2) {
			return ''
		}

		return `/icons/${props.icon[0]}/${props.icon[1]}.svg`
	})
</script>
